import { Component, EventEmitter, Input, Output } from '@angular/core'

@Component({
  selector: 'basin-app-column',
  templateUrl: './app-column.component.html',
  styleUrls: ['./app-column.component.scss'],
})
export class AppColumnComponent {
  @Input() columnCollapsed: boolean = false
  @Input() horizontal: boolean = false
  @Input() width: string = '25rem'
  @Input() height: string = '25rem'
  @Output() columnCollapsedChange: EventEmitter<boolean> =
    new EventEmitter<boolean>()

  columnToggleClicked() {
    this.columnCollapsed = !this.columnCollapsed
    this.columnCollapsedChange.emit(this.columnCollapsed)
  }
}
